import dayjs from "dayjs";
var weekOfYear = require('dayjs/plugin/weekOfYear')
dayjs.extend(weekOfYear);

export function getMonth(month = dayjs().month()) {
  month = Math.floor(month);
  const year = dayjs().year();
  const firstDayOfTheMonth = dayjs(new Date(year, month, 1)).day();
  let currentMonthCount = 0 - firstDayOfTheMonth;
  const daysMatrix = new Array(5).fill([]).map(() => {
    return new Array(7).fill(null).map(() => {
      currentMonthCount++;
      return dayjs(new Date(year, month, currentMonthCount));
    });
  });
  return daysMatrix;
}

// export function getWeek(week = dayjs().weeks()) {
//   week = Math.floor(week);
//   const month = dayjs().month();
//   const firstDayOfTheWeek = dayjs(new Date(month, week, 1)).day();
//   let currentWeekCount = 0 - firstDayOfTheWeek;
//   const daysMatrix = new Array(7).fill([]).map(() => {
//     currentWeekCount++;
//     return dayjs(new Date(month, week, currentWeekCount));
//   });
//   return daysMatrix;
// }

function CalculateDayOfWeek(date) {
  var days = [];
  for (var i = 0; i < 7; i++) {
    days[i] = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate() - date.getDay() + 1 + i
    );
  }
  return days;
}

export function getWeek() {
  var weekNo = dayjs().week() - 1;
  var d = new Date(new Date().getFullYear(), 0, 1);
  var newDate = new Date(dayjs(d).add(weekNo * 7, 'day').format("MM-DD-YYYY"));
  var dates = [];
  dates = CalculateDayOfWeek(newDate);
  const daysMatrix = [];
  for(var i = 0; i< dates.length ; i++){
    daysMatrix.push( dayjs(new Date(dates[i])))
  }
  
  return daysMatrix;
}
